import {Box, BoxProps} from "@mui/material";
import {Close} from "@mui/icons-material";
import React from "react";

export interface CloseIconButtonProps extends Omit<BoxProps, 'onClick'> {
  onClose: () => void;
}

export default function CloseIconButton({onClose, sx, ...props}: CloseIconButtonProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box p={1} display='flex' alignItems='center' sx={{cursor: 'pointer', ...sx}} {...props} onClick={onClose}>
      <Close/>
    </Box>
  );
}
